export interface IProcurementLinkParams {
    username: string | null;
    password: string | null;
    hookUrl: string | null;
}

const decode = (value: string): string => {
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

// Reads the procurement login parameters straight from the raw link instead of the standard query-string parser,
// which splits a value at every `&`, cuts the link at `#` and turns `+` into a space - so a password or a HOOK_URL
// written without percent-encoding would arrive broken. The parameter names (any casing) are the only separators;
// everything between two of them is the value, including a `#`-fragment, `&`, `?`, `=` and `+`. Percent-encoded
// values are decoded; a value that is not valid percent-encoding is kept as written.
export const parseProcurementLink = (search: string, hash: string): IProcurementLinkParams => {
    const query = search.replace(/^\?/, '');
    const fragment = hash.replace(/^#/, '');
    const raw = fragment ? `${query}#${fragment}` : query;

    const marker = /(?:^|&)(username|password|HOOK_URL)=/gi;
    const found: { key: string; markerStart: number; valueStart: number }[] = [];
    let match: RegExpExecArray | null;
    while ((match = marker.exec(raw)) !== null) {
        found.push({
            key: match[1].toLowerCase(),
            markerStart: match.index,
            valueStart: match.index + match[0].length,
        });
    }

    const values: Record<string, string> = {};
    found.forEach((item, index) => {
        if (item.key in values) {
            return;
        }
        const end = index + 1 < found.length ? found[index + 1].markerStart : raw.length;
        values[item.key] = decode(raw.slice(item.valueStart, end));
    });

    return {
        username: values['username'] || null,
        password: values['password'] || null,
        hookUrl: values['hook_url'] || null,
    };
};
